import { ReactNode, useEffect, useRef, useState } from "react";
import { Tooltip } from "antd";
import { Trans } from "react-i18next";
import { Highlight } from "@components/Highlight/Highlight";
import { twMerge } from "tailwind-merge";

interface ITitle {
  delay?: number;
  text: string | ReactNode;
  placement?:
    | "top"
    | "left"
    | "right"
    | "bottom"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom";
  styles?: {};
  className?: string;
  innerClassName?: string;
  overlayStyle?: {};
  lineclamp2?: boolean;
  children?: ReactNode;
  highLightWord?: string;
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
}
export default function TruncateTitle({
  delay = 300,
  text,
  placement = "top",
  styles,
  overlayStyle = {},
  className,
  innerClassName,
  lineclamp2 = false,
  children,
  highLightWord,
  getPopupContainer,
  ...rest
}: ITitle) {
  const ref = useRef<HTMLDivElement>(null);
  const [isOver, setIsOver] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // 外层宽度动画会导致 el 宽度识别不准
    setTimeout(() => {
      if (lineclamp2) {
        setIsOver(el.scrollHeight - el.clientHeight >= 1);
      } else {
        const isOverflow = el.scrollWidth - el.offsetWidth >= 1;
        setIsOver(isOverflow);
      }
    }, delay);
  }, [lineclamp2, rest]);

  const innerText = typeof text === "string" ? <Trans>{text}</Trans> : text;
  return (
    <Tooltip
      placement={placement}
      classNames={{ root: "ellipse-tool-tip" }}
      styles={{ root: { ...overlayStyle, zIndex: 1000 } }}
      title={() => {
        return <div onClick={(event) => event.stopPropagation()}>{innerText}</div>;
      }}
      open={isOver ? undefined : false}
      trigger="hover"
      {...(getPopupContainer ? { getPopupContainer } : {})}
    >
      <div className={["max-w-full", className].join(" ")}>
        <div
          ref={ref}
          style={{
            ...styles,
          }}
          className={twMerge(
            lineclamp2 ? "line-clamp-2" : "block whitespace-nowrap overflow-hidden text-ellipsis line-clamp-1",
            innerClassName,
          )}
          {...rest}
        >
          {children}
          {!!highLightWord && typeof text === "string" ? (
            <Highlight text={text} highlight={highLightWord}></Highlight>
          ) : (
            innerText
          )}
        </div>
      </div>
    </Tooltip>
  );
}
